'use strict';
const angular = require('angular');
import ProductsController from './products.controller';
import routes from './products.routes';

export default angular.module('nomasvelloDashboardApp.products', [])
    .config(routes)
    .controller('ProductsController', ProductsController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/products/index.ts